var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"border border-dark fs-m font-weight-bold px-1 m-0"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }